import SentryService from '../sentry/Sentry.service';
import useConfigStore from '@/stores/useConfigStore';

class AuthService {
  static async resetPassword(token: string, userEmail: string) {
    const environment = useConfigStore.getState().environment;

    try {
      const response = await fetch(
        `${environment.server.baseUrl}/api/auth/reset-password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            email: userEmail,
          }),
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || 'Failed to send password reset email',
        );
      }

      return { success: true };
    } catch (error) {
      SentryService.captureError('Password reset request failed', error);
      throw error;
    }
  }
}

export default AuthService;
